import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";

const BackgroundGradient = () => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    const bg = theme.palette.background.default;
    const paper = theme.palette.background.paper;
    const primary = theme.palette.primary.dark;
    const primaryLight = theme.palette.primary.light;
    const grey400 = theme.palette.grey[400];
    const grey600 = theme.palette.grey[600];

    // Much more subtle on dark, natural on light
    const o1 = isDark ? "18" : "cc"; // paper blob
    const o2 = isDark ? "18" : "55"; // primary dark blob
    const o3 = isDark ? "12" : "44"; // grey600 blob
    const o4 = isDark ? "0e" : "22"; // primaryLight blob
    const o5 = isDark ? "0a" : "18"; // grey400 center blob

    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                zIndex: -1,
                backgroundColor: bg,
                backgroundImage: `
                    radial-gradient(ellipse 80% 60% at 15% 20%, ${paper}${o1} 0%, transparent 60%),
                    radial-gradient(ellipse 60% 50% at 80% 10%, ${primary}${o2} 0%, transparent 55%),
                    radial-gradient(ellipse 50% 60% at 90% 70%, ${grey600}${o3} 0%, transparent 50%),
                    radial-gradient(ellipse 70% 50% at 10% 80%, ${primaryLight}${o4} 0%, transparent 55%),
                    radial-gradient(ellipse 60% 40% at 50% 50%, ${grey400}${o5} 0%, transparent 60%)
                `,
            }}
        />
    );
};

export default BackgroundGradient;